/* This file is autogenerated by "pnpm run generateIconComponents" command */
import React from 'react';
import { SVGProps } from 'react';

const Error: React.FC<SVGProps<SVGSVGElement>> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="m12 2.414-.6562 1.125-9 15.586-.6329 1.125h20.5782l-.6329-1.125-9-15.586zm0 3 7.6875 13.336H4.3125zm-.75 5.086V15h1.5v-4.5zm0 5.25v1.5h1.5v-1.5z"/></svg>
);

export default Error;
